import c from "react";
const u = ({
  appearance: t = "solid",
  intent: o = "neutral",
  size: e = "48",
  disabled: i = !1
}) => {
  const n = {
    24: "14",
    32: "18",
    40: "20",
    48: "20",
    56: "20"
  }[e], r = i ? {
    solid: "component/button/disabled/filled-icon",
    outline: "graphic/interactive/disabled/high",
    ghost: "graphic/interactive/disabled/high"
  }[t] : {
    prominent: {
      solid: "base/white/white",
      outline: "text/status-prominent",
      ghost: "text/status-prominent"
    },
    neutral: {
      solid: "base/white/white",
      outline: "text/contrast-max",
      ghost: "text/contrast-max"
    },
    negative: {
      solid: "base/white/white",
      outline: "text/status-negative",
      ghost: "text/status-negative"
    }
  }[o][t];
  return { size: n, color: r, hasWrapper: !1 };
}, d = ({
  icon: t,
  appearance: o = "solid",
  intent: e = "neutral",
  size: i = "48",
  disabled: s = !1
}) => {
  if (typeof t == "function") {
    const {
      size: n,
      color: a,
      hasWrapper: l
    } = u({
      appearance: o,
      intent: e,
      size: i,
      disabled: s
    });
    return t({ size: n, color: a, hasWrapper: l });
  }
  return c.isValidElement(t) ? t : null;
};
d.displayName = "IconButtonIcon";
export {
  d as default
};
//# sourceMappingURL=IconButtonIcon.js.map
